import axios from 'axios';
import Promise from 'promise-polyfill';
import Modernizr from 'modernizr';
import svg4everybody from 'svg4everybody';
import 'element-closest';

export const PAGE_TITLE_PREFIX = 'Кубок Кремля Admin • ';

export default function configure() {
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = 'X-CSRFToken';

    svg4everybody();

    if (!Modernizr.promises) {
        window.Promise = Promise;
    }
}



// WEBPACK FOOTER //
// ./assets/app/common/Settings.js